<template>
  <div class="DiFangZhi">
    <Header1></Header1>
    <!-- <div style="width:100%;height:270px;background-color:gray;"></div> -->
    <div class="DiFangZhiHeader">当前位置：首页 > 地方志详情</div>
    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               width="30%">
      <span>此方志为非纯净版，如果想阅读请联系管理员</span>
      <span>联系电话:027-67868953</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="backList">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="用户下载"
               :visible.sync="dialogDownLoadVisible">
      <el-form :model="dwonform">
        <el-button type="text"
                   style="text-align: left; font-size: 20px; width: 100%; display: block; border-bottom: 1px solid rgb(228, 225, 225); color:rgb(123, 123, 123) ;">
          申请列表
        </el-button>
        <el-table :data="tableData"
                  stripe
                  style="width: 100%">
          <el-table-column label="申请内容"
                           width="180">
            <template slot-scope="scope">
              <i class="el-icon-time"></i>
              <span style="margin-left: 10px;
								width: 120px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;">
                {{ scope.row.rollname }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="起始页"
                           width="90">
            <template slot-scope="scope">
              <i class="el-icon-date"></i>
              <span style="margin-left: 5px">{{ scope.row.downloadpage }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束页"
                           width="90">
            <template slot-scope="scope">
              <i class="el-icon-date"></i>
              <span style="margin-left: 5px">{{ scope.row.downloadnumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="申请时间"
                           width="190">
            <template slot-scope="scope">
              <span style="margin-left: 5px">{{ scope.row.downloadertime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态"
                           width="90">
            <template slot-scope="scope">
              <span style="margin-left: 5px; color: #FF3300;"
                    v-if="scope.row.auditstatus == 0">审核中</span>
              <span style="margin-left: 5px; color:#00ff00;"
                    v-if="scope.row.auditstatus == 1">审核通过</span>
              <span style="margin-left: 5px; color:red;"
                    v-if="scope.row.auditstatus == 2">审核不通过</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.auditstatus == 1"
                         size="mini"
                         @click="handleEdit(scope.$index, scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="text"
                   style="text-align: left; font-size: 20px; width: 100%; display: block; border-bottom: 1px solid rgb(228, 225, 225); color:rgb(123, 123, 123) ;">
          申请
        </el-button>
        <el-row style="text-align: center; margin-top: 30px;">
          <el-button type="text"
                     style="margin-right: 20px;">起始页</el-button>
          <el-input-number :min="1"
                           v-model="dwonform.begin"
                           autocomplete="off"></el-input-number>
          <el-button type="text"
                     style="margin-left: 30px; margin-right: 20px;">结束页</el-button>
          <el-input-number :min="1"
                           v-model="dwonform.end"
                           autocomplete="off"></el-input-number>
          <el-button type="success"
                     style="margin-left: 30px; margin-right: 20px;"
                     @click="downAll">整本下载</el-button>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align: center;">
        <el-button @click="dialogDownLoadVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="downloadApply">申 请</el-button>
      </div>
    </el-dialog>

    <div class="displayflex"
         style="width:80%; margin: 0 auto; box-sizing:border-box;"
         v-if="getBookListData.length > 0">
      <div style="width:20%; border-right:1px solid rgb(239, 236, 236);">
        <div style="color: rgb(75, 179, 165); font-size: 18px; text-align: left;font-weight: bold; padding:30px 0 ; padding-left: 4px;">
          {{ getBookListData[selectIndex].rollname }}
        </div>
        <div>
          <el-button type="primary"
                     style="margin-left:10px;padding: 10px 20px;"
                     @click="showDownView">下载</el-button>
          <div class="fr"
               style="width:30px;height:30px;margin-right:30px; cursor: pointer;"
               @click="collection">
            <img src="../assets/Img/icon_star01.png"
                 alt=""
                 srcset=""
                 style="width:100%;height:100%"
                 v-if="!iscollect"
                 class="animated heartBeat" />
            <img src="../assets/Img/icon_star02.png"
                 style="width:100%;height:100%"
                 class="animated heartBeat"
                 v-else />
          </div>
          <div style="padding: 22px 0px 0px; ">
            <div style="width: 90px;height: 48px;color: rgba(4, 195, 195, 1);font-size: 18px;text-align: left;font-weight: bold;line-height:40px;">文档属性：</div>
            <span class="attTittleStyle">类型:</span>
            <span class="attStyle">{{ getBookListData[selectIndex].rolltype }}</span>
            <br />
            <span class="attTittleStyle">地区层级:</span>
            <span class="attStyle1">{{ getBookListData[selectIndex].arealevel }}</span>
            <br />
            <span class="attTittleStyle">成书年份:</span>
            <span class="attStyle2">{{ getBookListData[selectIndex].year }}</span>
          </div>
          <div style="width:100%;height:1px;background-color: rgb(234, 234, 234);margin-top: 40px;"></div>
          <div>
            <span class="datalisttitle">其他地方志件列表:</span>
            <span class="datalisttitle1">共:{{ getBookListData.length }}卷</span>
          </div>
          <div style="height:300px; overflow: auto; width: 100%;">
            <div v-for="(item, index) in getBookListData"
                 style=" text-align:left; font-size:13px; color:rgb(63, 173, 159); line-height:40px; cursor: pointer;"
                 @click="clickIndex(item.filepath, index, item.ispure, item.pagenumber, item.id)"
                 :class="{ active: selectIndex === index }">
              <!-- <div style="display: inline; float: left;">
                    <i class="el-icon-document"></i>
                </div> -->
              <div class="rollnamelistitem">{{ item.rollname }}</div>
              <!-- <span id="tooltipId" v-show="isTooltip" style="position: relative;">asdf</span> -->
            </div>
          </div>
        </div>
      </div>
      <div style="flex:1;">
        <div style="margin-top:15px;">
          <iframe ref="iframes"
                  id="iframePreview"
                  width="100%"
                  height="700px"
                  style="vertical-align: middle;margin:10px;"></iframe>
          <!--  <pdf ref="pdfPage" :pdfUrl="pdfUrl"></pdf> -->
        </div>
      </div>
    </div>
    <Foot></Foot>

    <el-dialog :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="请输入短信验证码">
          <el-input autocomplete="off"
                    v-model="yzm"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="getyzm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header1 from '../components/Header1.vue';
import Foot from '../components/Foot.vue';
import pdf from '../components/pdf.vue';
import { MessageBox, Message, Progress, Loading } from 'element-ui';
import { request, fetch } from '../API/ApiUrl';

export default {
  name: 'detail',
  components: {
    Header1,
    Foot,
    pdf
  },

  data () {
    return {
      collect: '',
      types: '1',
      getBookListData: [],
      getToken: [],
      id: this.$route.query.id,
      isroll: this.$route.query.isroll,
      vid: this.$route.query.vid,
      dialogVisible: false, //false不现实true显示
      purity: {
        129: '有水印无图章',
        130: '无水印有图章',
        131: '有水印有图章',
        132: '纯净版'
      },
      dwonform: {
        begin: 0,
        end: 0
      },
      userInfo: {},
      iscollect: false,
      pdfUrl: '', //'/ftp/huashi/FileUpload2017/664abec7-2917-41c9-8d9a-7a3c2aff0a1d/20180114/201801141346_00000.pdf',
      pdfId: '',
      pdfPageCount: 0,
      dialogDownLoadVisible: false,
      selectIndex: 0,
      formLabelWidth: '90px',
      auditstatus: 3, // 审核状态 0：审核中  1：审核通过  2：审核不通过 3：未申请审核
      downLoadBeginPage: 0,
      downLoadEndPage: 0,
      pageArr: 0,
      base64Data: [],
      loading: '',
      count: '',
      tableData: [],
      row: '',
      yzm: '',
      yzmcode: '',
      dialogFormVisible: false,
    };
  },
  computed: {
    pageName () {
      const pageType = this.$route.query.type;
      if (pageType == 1) {
        return '地方志';
      }
      if (pageType == 2) {
        return '地方年鉴';
      }
      if (pageType == 3) {
        return '统计年鉴';
      }
    }
  },
  mounted () {
    this.id = this.$route.query.id;
    this.isroll = this.$route.query.isroll;
    if (sessionStorage.getItem('loginData')) this.userInfo = JSON.parse(sessionStorage.getItem('loginData'));
    // if (this.userInfo.userId) //console.log(123456)
    this.getBookList();
    this.getUserCollectStatu();
    this.addVisit();
  },
  methods: {
    //增加点击量
    addVisit () {
      request('/apiVisit/addVisitData', { module: 101 }).then(res => { });
    },

    startLoading: function () {
      //使用Element loading-start 方法
      this.loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    backList () {
      dialogVisible = false;
      this.$router.back('/DiFangZhi1');
    },
    //整本下载
    downAll () {
      this.dwonform.begin = 1;
      if (this.pdfPageCount <= 0) {
        this.pdfPageCount = this.$refs.iframes.contentWindow.PDFViewerApplication.pagesCount;
      }
      this.dwonform.end = this.pdfPageCount;
    },


    getyzm () {
      if (this.yzm == this.yzmcode) {
        this.down(this.row);
        this.dialogFormVisible = false;
      } else {
        this.$message.error('请输入正确的验证码')
        this.dialogFormVisible = true;
      }
    },
    //表格操作
    handleEdit (index, row) {
      this.row = row.id
      this.down(this.row);
      // this.dialogFormVisible = true;

      // request('api/sendValidateCode', {}).then(res => {
      //   //console.log(res);
      //   this.yzmcode = res.validateCode
      // })

    },
    clickIndex (itempath, index, ispure, pageCount, id) {
      if (ispure != 1) {
        this.dialogVisible = true;
        return;
      }
      this.pdfPageCount = pageCount;
      // var el = document.getElementById('div_read_area_scrool');
      //         var childs = el.childNodes;
      //         for(var i = childs .length - 1; i >= 0; i--) {
      //           el.removeChild(childs[i]);
      //         }
      if (ispure != 1) {
        this.dialogVisible = true;
        return;
      }
      this.pdfPageCount = pageCount;
      this.pdfUrl = this.$baseUrl + itempath;
      this.pdfId = id;
      this.selectIndex = index;
      if (this.userInfo.userId != null || this.userInfo.userId != '') {
        this.getCheckState();
      }

      // this.pdfUrl = "http://lggd.ccnu.edu.cn/ftp/huashi"+ itempath
      // this.pdfId = id
      // this.selectIndex = index
      // if(this.userInfo.userId != null || this.userInfo.userId != ""){
      //   this.getCheckState();
      // }
    },

    getLocalhistoryDownApply () {
      request('/apidfz/downloadapplylist', {
        userid: this.userInfo.userId,
        rollId: this.getBookListData[this.selectIndex].id,
        passflag: -1
      }).then(res => {
        //console.log(res);
        //console.log('-----------------');
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
    },
    getPdfFun (filePath) {

      var self = this;
      var url = self.$http.defaults.baseURL + 'apidfz/showPdf?path=' + self.pdfUrl + '&id=' + self.pdfId;

      var urlPath = document.URL.split('#');
      var temp;
      if (urlPath[0].indexOf('index.html') != -1) {
        temp = urlPath[0].substring(0, urlPath[0].indexOf('index.html'));
      } else {
        temp = urlPath[0];
      }
      if (url) {
        //console.log('============url:' + url);
        var tt = temp + 'pdf/web/viewer.html?file=' + encodeURIComponent(url);
        document.getElementById('iframePreview').src = tt;
      }
    },
    getPDFDetail () {
      request('/apidfz/detailLcDownLoadApplyByRollId', {
        userId: this.userInfo.userId,
        rollId: this.getBookListData[this.selectIndex].id,
        passflag: -1
      }).then(resp => {
        if (resp.code === 200) {
          this.pdfUrl = this.getBookListData[this.selectIndex].filepath;
          this.pdfId = this.getBookListData[this.selectIndex].id;
          this.getPdfFun();
          this.getLocalhistoryDownApply();
        }
      });
    },
    // 判断是否有审核申请
    getCheckState () {
      // this.startLoading();
      var itemData = this.getBookListData[this.selectIndex];
      if (itemData.ispure != 1) {
        //非纯净版
        if (this.userInfo.userId == null || this.userInfo.userId == '') {
          this.endLoading();
          this.dialogVisible = true;
        } else {
          if (this.userInfo.isHaveAuth == 1) {
            this.getPDFDetail();
          } else {
            this.endLoading();
            this.dialogVisible = true;
          }
        }
      } else {
        this.getPDFDetail();
      }
    },
    getBookList () {
      var tempData = {};
      tempData.userid = this.userInfo.userId;
      tempData.lctype = this.isroll;
      tempData.passflag = -1

      if (this.isroll === 1) {
        //册
        tempData.id = this.id;
      } else {
        //卷
        tempData.volumeid = this.id;
        tempData.rollid = this.vid;
      }
      request('apidfz/localHistoryBookDetail', tempData).then(res => {
        if (res.code === 200) {
          this.getBookListData = res.data.rollList;
          this.count = res.data.count;
          // this.iscollect = res.iscollect;
          if (this.getBookListData.length) {
            this.getCheckState();
          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
		/**
		 * 分页下载
		 **/
    async down () {
      // this.base64Data = [];
      // var self = this;
      //  //window.open(this.$baseUrl + this.getBookListData[this.selectIndex].filepath, '_blank')
      //  //this.$refs.iframe.contentWindow.PDFViewerApplication.download()
      // var i = self.downLoadBeginPage
      // setTimeout(function x(){
      //    self.$refs.iframes.contentWindow.PDFViewerApplication.page = i;
      //    self.downloadimage(self.$refs.iframes.contentWindow.document.getElementById('page'+i),i);
      //    ++i;
      //     if(i <= self.downLoadEndPage)setTimeout(x,300);
      //  },300);
      var self = this;
      request(
        '/apidfz/getPdfPages',
        {
          userId: this.userInfo.userId,
          rollId: this.getBookListData[this.selectIndex].id,
        },
        // {
        //   responseType: 'blob'
        // }
      )
        .then(res1 => {
          //console.log(res1)
          if (res1.code == 403) {
            this.$message({
              message: res1.msg,
              type: 'error'
            })
          } else {
            request(
              '/apidfz/getPdfPages',
              {
                userId: this.userInfo.userId,
                rollId: this.getBookListData[this.selectIndex].id,
              },
              {
                responseType: 'blob'
              }
            ).then(res => {
              if (res) {
                const fileName = self.getBookListData[self.selectIndex].rollname + self.downLoadBeginPage + '-' + self.downLoadEndPage + '页.pdf';
                if ('download' in document.createElement('a')) {
                  // 非IE下载
                  const elink = document.createElement('a');
                  elink.download = fileName;
                  elink.style.display = 'none';
                  elink.href = window.URL.createObjectURL(res);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              }
            })
          }

        })

    },
    exportPdf (urltopdf) {
      var URL = window.URL || window.webkitURL;
      function saveAs (blob, filename) {
        var type = blob.type;
        var force_saveable_type = 'application/octet-stream';
        if (type && type != force_saveable_type) {
          // 强制下载，而非在浏览器中打开
          var slice = blob.slice || blob.webkitSlice || blob.mozSlice;
          blob = slice.call(blob, 0, blob.size, force_saveable_type);
        }
        var url = URL.createObjectURL(blob);
        var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = url;
        save_link.download = filename;

        var event = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        save_link.dispatchEvent(event);
        URL.revokeObjectURL(url);
      }
      var oReq = new XMLHttpRequest();
      // The Endpoint of your server
      var urltopdf = urltopdf;
      // Configure XMLHttpRequest
      oReq.open('GET', urltopdf, true);
      // Important to use the blob response type
      oReq.responseType = 'blob';
      // When the file request finishes
      // Is up to you, the configuration for error events etc.
      oReq.onload = function () {
        // Once the file is downloaded, open a new window with the PDF
        // Remember to allow the POP-UPS in your browser
        var file = new Blob([oReq.response], {
          type: 'application/pdf'
        });
        // Generate file download directly in the browser !
        saveAs(file, 'mypdffilename.pdf');
      };
      oReq.send();
    },
		/**
		 *
		 **/
    downOnAudit () {
      this.$message({
        message: '文件下载正在审核中，请耐心等待!',
        type: 'success'
      });
    },
		/**
		 * 申请下载
		 **/
    downloadApply () {
      if (this.userInfo.userId == null || this.userInfo.userId == '') {
        this.$router.push('/login');
        return;
      }
      if (this.dwonform.begin > this.dwonform.end) {
        this.$message({
          message: '起始页不能大于结束页',
          type: 'error'
        });
        return;
      }
      // //console.log("==================?????????=====================");
      if (this.pdfPageCount <= 0) {
        this.pdfPageCount = this.$refs.iframes.contentWindow.PDFViewerApplication.pagesCount;
      }
      //console.log(this.pdfPageCount + "------");
      if (this.dwonform.begin > this.pdfPageCount) {
        this.$message({
          message: '起始页不能大于该文件总页数!',
          type: 'error'
        });
        return;
      }

      if (this.dwonform.end > this.pdfPageCount) {
        this.$message({
          message: '结束页不能大于该文件总页数!',
          type: 'error'
        });
        return;
      }
      request('/apidfz/applyDouwnload', {
        userId: this.userInfo.userId,
        id: this.getBookListData[this.selectIndex].id,
        beginPage: this.dwonform.begin,
        endPage: this.dwonform.end,
        // passflag: -1
      }).then(res => {
        if (res.code === 200) {
          this.dialogDownLoadVisible = false;
          this.auditstatus = 0;
          this.$message({
            type: 'success',
            message: res.msg
          });
          this.getLocalhistoryDownApply();
        } else {
          this.dialogDownLoadVisible = false;
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
    showDownView () {
      if (this.userInfo.userId == null || this.userInfo.userId == '') {
        this.$router.push('/login?type=1');
        return;
      }
      if (this.userInfo) {
        this.dialogDownLoadVisible = true;
      } else {
        this.$router.push('/login?type=1');
      }
    },
    downloadimage: function (canvas, idx) {
      // 图片导出为 png 格式
      var type = 'png';
      // 返回一个包含JPG图片的<img>元素
      var img_png_src = canvas.toDataURL('image/png', 0.8); //将画板保存为图片格式的函数
      // 加工image data，替换mime type
      img_png_src = img_png_src.replace(this._fixType(type), 'image/octet-stream');
      // 下载后的问题名
      var filename = '地方志_' + new Date().getTime() + '_' + idx + '.' + type;
      var blob = this.base64Img2Blob(img_png_src);
      this.base64Data.push(img_png_src);
      // download
      if (idx === this.downLoadEndPage) {
        //this.saveFile(filename);
        this.drawCanvas(canvas.width + 10, canvas.height + 10);
      }
    },
    drawCanvas: function (width, height) {
      var self = this;

      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var imglen = parseInt(self.downLoadEndPage) - parseInt(self.downLoadBeginPage);
      canvas.width = width;
      canvas.height = height * imglen;

      var drawimg = (function f (n) {
        if (n < imglen) {
          var img = new Image();
          img.crossOrigin = 'Anonymous'; //解决跨域问题
          img.onload = function () {
            //ctx.save();
            if (n == 0) {
              ctx.drawImage(img, 0, 0, width, height);
            } else {
              ctx.drawImage(img, 0, height * n, width, height);
            }
            f(n + 1);
          };

          img.src = self.base64Data[n];
        } else {
          self.saveFile(
            canvas.toDataURL('image/jpeg'),
            self.getBookListData[self.selectIndex].rollname + self.downLoadBeginPage + '-' + self.downLoadEndPage + '页.jpeg'
          );
        }
      })(0);
    },
		/**
		 * 在本地进行文件保存
		 * @param  {String} data         要保存到本地的图片数据
		 * @param  {String} filename     文件名
		 */
    saveFile: function (data, filename) {
      var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      var blob = this.base64Img2Blob(data);
      save_link.href = URL.createObjectURL(blob);
      save_link.download = filename;

      var event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      save_link.dispatchEvent(event);
    },
		/**
		 * 获取mimeType
		 * @param  {String} type the old mime-type
		 * @return the new mime-type
		 */
    _fixType: function (type) {
      type = type.toLowerCase().replace(/jpg/i, 'jpeg');
      var r = type.match(/png|jpeg|bmp|gif/)[0];
      return 'image/' + r;
    },
    canvas2img (canvas) {
      var image = new Image();
      image.src = canvas.toDataURL('image/png');
      return image;
    },
    base64Img2Blob: function (code) {
      var parts = code.split(';base64,');
      var contentType = parts[0].split(':')[1];
      var raw = window.atob(parts[1]);
      var rawLength = raw.length;

      var uInt8Array = new Uint8Array(rawLength);

      for (var i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    },
    //获取状态
    getUserCollectStatu () {
      if (this.userInfo.userId != null || this.userInfo.userId != '') {
        request('/apidfz/getUserCollectStatu', { userid: this.userInfo.userId, rollid: this.vid, passflag: -1 }).then(res => {
          if (res.code === 200) {
            this.collect = res.data.isCollect;
          }
          if (this.collect == 1) {
            this.iscollect = true;
          }
          if (this.collect == 2) {
            this.iscollect = false;
          }
        });
      }
    },
    // 收藏及取消收藏
    collection () {
      if (this.userInfo.userId == null || this.userInfo.userId == '') {
        this.$router.push('/login?type=1');
        return;
      }
      if (this.iscollect == false) {
        this.types = 1;
      } else if (this.iscollect == true) {
        this.types = 2;
      }
      request('/apidfz/localHistoryCollect', {
        userid: this.userInfo.userId,
        username: this.userInfo.username,
        rollid: this.vid,
        rollname: this.getBookListData[0].rollname,
        type: this.types,
        // passflag: -1
        // type: this.iscollect ? 2 : 1
      }).then(res => {
        //console.log(res);
        if (res.code === 200) {
          this.iscollect = !this.iscollect;
          // this.getBookList()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      });
    }
  }
};
</script>
<style scoped>
.DiFangZhi {
  margin: 0 auto;
  width: 100%;
}

.DiFangZhiHeader {
  text-align: left;
  width: 80%;
  box-sizing: border-box;
  font-size: 15px;
  padding-bottom: 15px;
  padding-top: 15px;
  margin: auto;
  margin-top: 10px;
  border-bottom: 1px solid #e2ece8;
}

.Index {
  border: 2px solid #eef2f3;
  padding: 58px 55px 38px 68px;
}

.IndexHeader {
  text-align: center;
  font-size: 42px;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  border-bottom: 46px;
}

.IndexHeaderTitle {
  display: flex;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  justify-content: space-between;
  padding-bottom: 31px;
  padding-top: 46px;
}

.IndexHeaderTitleOne {
  display: flex;
  align-items: center;
}

.IndexHeaderTitleOne > div:nth-child(1) {
  margin-right: 24px;
}

.IndexHeaderTitleZt {
  display: flex;
}

.IndexHeaderTitleZt > div {
  margin-right: 7px;
  width: 98px;
  height: 34px;
  background: rgba(218, 218, 218, 1);
  line-height: 34px;
  text-align: center;
  border-radius: 20px;
}

.Img {
  height: 587px;
  width: 100%;
  background: #eef2f3;
}

.Foot {
  display: flex;
  padding: 18px 0 0 0;
  justify-content: space-between;
  align-items: center;
}

.FootLeft {
  width: 255px;
  height: 236px;
  border: 1px solid rgba(209, 209, 209, 1);
  background: #eef2f3;
  font-size: 15px;
  box-sizing: border-box;
}

.FootLeftHeader {
  font-size: 18px;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  padding-top: 23px;
  padding-left: 32px;
  text-align: left;
}

.FootLeftInput {
  display: flex;
  justify-content: center;
  align-items: center;
}

.FootLeftInput > div {
  margin-right: 13px;
}

.FootLeftInput > input {
  width: 151px;
  height: 42px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 215, 1);
}

.padding {
  margin-top: 15px;
  margin-bottom: 12px;
}

.FootLeftXiaZai {
  width: 151px;
  height: 42px;
  background: #1d365e;
  margin: 0 auto;
  margin-top: 19px;
  color: #fff;
  line-height: 42px;
}

.FootCenter {
  width: 283px;
  height: 236px;
  border: 1px solid rgba(209, 209, 209, 1);
  padding: 23px 0 0px 31px;
  text-align: left;
  background: #eef2f3;
  box-sizing: border-box;
}

.FootCenterHeader {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  margin-bottom: 22px;
}

.FootCenterIndex {
  font-size: 14px;

  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  line-height: 30px;
}

.FootCenterXiaZai {
  width: 151px;
  height: 42px;
  background: #1d365e;
  margin: 0 auto;
  margin-top: 19px;
  color: #fff;
  line-height: 42px;
  text-align: center;
  font-size: 15px;
  margin-top: 42px;
}

.FootRight {
  width: 632px;
  height: 236px;
  border: 1px solid rgba(209, 209, 209, 1);
  box-sizing: border-box;
  padding: 21px 23px 28px 27px;
}

.FootRightHeader {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  padding-bottom: 16px;
}

.FootRightHeader > div:nth-child(2) {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(139, 139, 139, 1);
}

.FootRightImg {
  display: flex;
  justify-content: space-between;
}

.FootRightImgList > div:nth-child(1) {
  width: 180px;
  height: 129px;
  background: #eef2f3;
  margin-bottom: 9px;
}

.FootRightImgList > div:nth-child(2) {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  width: 180px;
  align-items: left;
}

.active {
  background: #eaf5ff;
}
.attTittleStyle {
  font-size: 14px;
}
.attStyle {
  background-color: #ffffff;
  color: #409eff;
  font-size: 16px;
  font-weight: bold;
}
.attStyle1 {
  background-color: #ffffff;
  color: #409eff;
  margin-top: 10px;
  margin-left: 0px;
  font-size: 16px;
  font-weight: bold;
}
.attStyle2 {
  color: #409eff;
  background-color: #ffffff;
  margin-top: 10px;
  margin-left: 0px;
  font-size: 16px;
  font-weight: bold;
}
.rollnamelistitem {
  /* margin-left: 12px; */
  white-space: nowrap;
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.datalisttitle {
  color: rgb(75, 179, 165);
  font-size: 16px;
  text-align: left;
  padding: 19px 0px 19px 0px;
}
.datalisttitle1 {
  color: rgb(4, 195, 195);
  font-size: 14px;
  padding: 19px 0px 19px 0px;
  text-align: right;
  width: 32%;
  font-weight: bold;
}
</style>
